import { render, staticRenderFns } from "./vsTooltip.vue?vue&type=template&id=14487e84"
import script from "./vsTooltip.vue?vue&type=script&lang=js"
export * from "./vsTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports